import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CuttingButt } from '../../models/cutting/cutting-butt.model';
import { CuttingHandle } from '../../models/cutting/cutting-handle.model';
import { CuttingMatBaseGroup } from '../../models/cutting/cutting-material-group.model';

export interface HandlesResponse {
  materialsDTO: CuttingHandle[];
  materialsCount: number;
}

@Injectable()
export abstract class HandlesDialogService {
  public abstract getHandles(
    groupId: number,
    pageSize: number,
    pageIndex: number,
    filterText: string
  ): Observable<HandlesResponse>;

  public abstract getHandleGroupsFromMatBase(): Observable<CuttingMatBaseGroup[]>;
}
